import { notification } from '@surecompanies/core_components'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { CompanyStatusEnum } from 'constants/company'
import client from 'enrollment-platform/api/eps.client'
import { CUSTOMER_MANAGEMENT } from 'enrollment-platform/pages/CustomerManagement/paths'
import { browserHistory } from 'react-router'

export default function useEditCustomer({ id }: { id: number }) {
  const queryClient = useQueryClient()
  const updateCustomer = async (data: any) => {
    try {
      await client.put(`/customers/${id}`, {
        ...data,
        isActive: data.status === CompanyStatusEnum.ACTIVE,
      })
      notification.success({
        message: 'Customer was successfully updated',
      })
      queryClient.invalidateQueries({ queryKey: ['getCustomer', id] })
      browserHistory.push(`/${CUSTOMER_MANAGEMENT}/${id}/view`)
    } catch (error: any) {
      console.log(error?.response?.data?.message, 'error')
      notification.error({
        message: 'Something went wrong updating the customer',
      })
    }
  }

  const { mutate, isPending } = useMutation({
    mutationFn: updateCustomer,
    mutationKey: ['updateCustomer', id],
  })
  return {
    mutate,
    isPending,
  }
}
